"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickFreeModuleGiveUpSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickFreeModuleGiveUpSchema extends baseClickSchema_1.BaseClickSchema {
    constructor() {
        super({ componentName: 'FreeModuleModalGiveUpButton' });
        this.action = baseSchema_1.ActionsName.CLICK_FREE_MODULE_GIVE_UP;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action
        };
    }
}
exports.ClickFreeModuleGiveUpSchema = ClickFreeModuleGiveUpSchema;
